RivalIQ.apps.Insights.module('collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    const Posts = collections.Posts = Backbone.Collection.extend({
        model: App.models.Post,

        url: function () {

            const me = this;
            return `/api/company/${me.companyId}/insights/${me.channel}/content?${me.getUrlParams()}`;
        },

        getUrlParams: function () {

            const me = this;
            const timePeriod = RivalIQ.state.view.get('timePeriod');

            const params = _.extend({
                timePeriod: RivalIQ.utils.timePeriod.serializeForAjax(timePeriod)
            }, _.pick(me, 'sort', 'sortOrder', 'page', 'pageSize', 'postType'));

            return $.param(params);
        }
    });

    /**
     * Creates a posts collection for the specified company, channel, and time period.
     * @param companyId
     * @param channel
     * @param timePeriod
     * @param [sort]
     * @param [sortOrder]
     * @param [page]
     * @param [pageSize}
     * @param [postType}
     */
    Posts.create = function (companyId, channel, timePeriod, sort, sortOrder, page, pageSize, postType) {

        return _.extend(new Posts(), {
            channel: channel,
            companyId: companyId,
            timePeriod: timePeriod,
            sort: sort,
            sortOrder: sortOrder,
            page: page,
            pageSize: pageSize,
            postType: postType
        });
    };

});
